





































































import { Component, Vue, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import SuporteSalasRoboticasStore from '@/components/Suporte/Store/SuporteSalasRoboticasStore'

@Component
export default class ModalSuporteSalaRobotica extends Vue {
  loadingSave: boolean = false
  statusOptions = ['Ativo', 'Inativo']

  get store() {
    return getModule(SuporteSalasRoboticasStore, this.$store)
  }

  get showModal() {
    return this.store.modal.salaRobotica
  }

  set showModal(value: boolean) {
    this.store.setModal({ name: 'salaRobotica', value })
  }

  $refs!: {
    formSalaRobotica: any
  }

  rules: any = {
    descricao: [(v: any) => !!v || 'Campo obrigatório.'],
    status: [(v: any) => !!v || 'Campo obrigatório.'],
  }

  async saveOrUpdate() {
    if (!this.$refs.formSalaRobotica.validate()) return

    this.loadingSave = true
    const { mode } = this.store

    const response = await this.store.upsertSalaRobotica()

    if (response.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `Robô ${mode === 'CREATE' ? 'adicionado' : 'atualizado'} com sucesso!`,
        icon: 'done',
        color: '#2E7D32',
      })
      await this.store.getSalasRoboticas()
      this.showModal = false
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message || `Ocorreu um erro ao ${mode === 'CREATE' ? 'adicionar' : 'atualizar'} o robô.`,
        icon: 'warning',
        color: '#C62828',
      })
    }

    this.loadingSave = false
  }

  @Watch('showModal')
  onChangeShowModal(value: boolean) {
    if (!value) {
      this.store.clearSalaRobotica()
      this.store.setMode({ mode: 'CREATE' })
      this.$refs.formSalaRobotica.resetValidation()
    }
  }
}
